/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Porcentaje de tipos de lanzamiento por tramo de tiempo.
 */
export interface TimeIntervalThrowTypeDTO { 
    interval_label: string;
    throw_type_percentages: { [key: string]: number; };
    throw_type_counts?: { [key: string]: number; } | null;
    total_throws?: number | null;
}

